import React from "react";
import { processStatisticsPercentage, renderStatistics } from "@/modules/statistics";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";
import { monopolyCircles, monopolySquares } from "@/modules/commonMobile";

export default class M20 extends IGameStatisticsClass {
	constructor() {
		super(null);

		this.filtrate = function(history, filter) {
			const total = history.length;
			
			switch (filter) {
				case "circle-square-others":
					let circle = 0, square = 0, other = 0;
					history.forEach(item => {
						if (monopolyCircles.indexOf(item.angka) >= 0)
							circle++;
						else if (monopolySquares.indexOf(item.angka) >= 0)
							square++;
						else other++;
					});
					
					this.statisticsArray.top.push([
						<div key="m20gst_0" className="sl-roadmap-circle red-bg"></div>,
						<div key="m20gst_1" className="sl-roadmap-square blue-bg"></div>,
						<div key="m20gst_2" className="sl-roadmap-circle green-bg"></div>
					]);
	
					this.statisticsArray.bottom.push(
						[ circle, square, other ].map((item, idx) =>
							processStatisticsPercentage(`m20gsb_${idx}`, item, total)
						)
					);
				break;
				default: break;
			}
		};
	}

	
		
	render() {
		return renderStatistics(this);
	}
}
